import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const HELP = {
  sales_invoice: "Sales invoices", purchase_bill: "Purchase bills (our internal bill no.)",
  credit_note: "Credit notes", receipt: "Receipts",
};

export function InvoiceNumberLock() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings/number-locks").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const toggle = async (kind, v) => {
    try {
      await api.put("/settings/number-locks", { kind, locked: v });
      setS({ ...s, locks: { ...s.locks, [kind]: v } });
      toast.success(`${HELP[kind]}: ${v ? "numbers locked to the series" : "users can type their own number"}`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="border rounded-sm p-3 bg-muted/30 space-y-2" data-testid="invoice-number-lock">
      <div>
        <div className="text-sm font-medium">Lock document numbers</div>
        <div className="text-xs text-muted-foreground">When on, numbers always follow the series and users cannot type their own.
          {!s.can_edit && " Only the owner, CFO or admin can change this."}</div>
      </div>
      <div className="grid sm:grid-cols-2 gap-2">
        {Object.keys(HELP).map((k) => (
          <label key={k} className="flex items-center justify-between bg-white border rounded-sm px-3 py-2 text-sm">
            <span>{HELP[k]}</span>
            <Switch checked={!!s.locks?.[k]} onCheckedChange={(v) => toggle(k, v)} disabled={!s.can_edit} data-testid={`number-lock-${k}`} />
          </label>
        ))}
      </div>
    </div>
  );
}
